var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMergeStudio = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.658 15.41h-4.79A1.37 1.37 0 0 1 5.5 14.044v-8.18c0-.754.613-1.364 1.368-1.364h8.21v1.364h-8.21v8.181h4.79v-1.363l2.737 2.045-2.737 2.046zm5.474 2.726V8.591H9.605v4.09H8.237v-4.09c0-.753.613-1.364 1.368-1.364h7.527c.755 0 1.368.61 1.368 1.364v9.545c0 .753-.613 1.364-1.368 1.364H9.605c-.755 0-1.368-.61-1.368-1.364v-1.363h1.368v1.363z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMergeStudio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merge-studio.c038da7a.svg";